import request from "@/utils/request"

/**
 * 封装postForm请求
 * postJson
 */
export const postForm = (url, params) => {
    return request({
        url: url,
        method: "post",
        headers: { "Content-Type": "multipart/form-data" },
        data: objCoverFormData(params),
        $_isFormData: true
    })
}

export function objCoverFormData(params) {
    let formData = new FormData()
    if (params) {
        for (let k in params) {
            if (Array.isArray(params[k])) {
                formData.append(k, params[k].join(","))
                continue
            }
            if (typeof params[k] === typeof {}) {
                continue
            }
            if (params[k] === null || params[k] === undefined) {
                continue
            }
            formData.append(k, params[k])
        }
    }
    return formData
}

export class FormValid {
    /**
     * 创建一个表单验证
     * form = {username: "jethro"}
     * rules={
     *     username: [
     *         new ValidRules(validator.isEmail, "请输入正确email")
     *     ]
     * }
     * @param rules {Object}
     */
    constructor(rules) {
        this.rules = rules
    }

    /**
     * 验证表单并返回错误消息列表
     * @param formObject {Object}
     * @return {[String]}
     */
    valid(formObject) {
        let message = []
        Object.keys(this.rules).forEach((key) => {
            let value = formObject[key]
            let rules = this.rules[key]
            rules.some(rule => {
                if (rule instanceof ValidRule) {
                    if (rule.valid(value)) {
                        message.push(rule.errorMsg)
                        return true
                    }
                }
            })
        })
        return message
    }
}

export class ValidRule {
    constructor(validator, errorMsg) {
        this.errorMsg = errorMsg
        this.validator = validator
    }

    /**
     * 创建一个非空验证器，当数据不为空时返回true
     * @param errorMsg
     * @return {ValidRule}
     */
    static required(errorMsg) {
        const v = (value) => {
            if (value == null) return false;
            if (value === "") return false;
            if (value instanceof Object) {
                if (Object.keys(value).length === 0) return false
            }
            return !(value instanceof Array && value.length === 0);
        }
        return new ValidRule(v, errorMsg)
    }

    /**
     * 验证数据
     * @param value 数据
     * @return {String} 如果验证不通过则返回错误消息
     */
    valid(value) {
        if (!this.validator(value)) {
            return this.errorMsg;
        }
    }
}

/**
 * 验证 quill 富文本编辑器内容物是否为空
 * @param content
 */
export function quillEmpty(content) {
    if (content === null || content === "") return true;
    if (Array.isArray(content) && content.length === 0) return true;
    if (content === "<p><br></p>") return true;
    return false;
}

export const jsonHeaders = {
    "Content-Type": "application/json;charset=UTF-8"
}
